import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import "./NotFound.scss";

export default function NotFound() {
  return (
    <div className="notfound">
      <Header />
      <main className="notfound__body">
        <p className="notfound__code">Error 404</p>
        <h1 className="notfound__title">Lost the melody</h1>
        <p className="notfound__text">
          We couldn't find that page.
        </p>
        <Link to="/" className="notfound__link">
          Back to start
        </Link>
      </main>
    </div>
  );
}
